import Labels from '../components/labels/labels.vue'
import Royalties from '../components/royalties/royalties.vue'
import Releases from '../components/releases/releases.vue'
import UserProfile from '../components/user-profile/user-profile.vue'
import Extension from '../extension'
import NotFound from '../notfound.vue'
import Home from '../components/home/b2b-home.vue'
import { FixedProperties } from '../models/Fixed-Properties'
import { RequireGuradChecked,InitB2bLanguage } from './route'

export default [
  {
    path: '/b2b',
    name: 'B2B',
    component: Extension,
    redirect: FixedProperties.HOME_ROUTE,
    beforeEnter: InitB2bLanguage,
    children: [

      {
        path: FixedProperties.HOME_ROUTE,
        name: FixedProperties.HOME_TITLE,
        component: Home,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'labels',
        name: 'Labels',
        component: Labels,
        beforeEnter: RequireGuradChecked

      },
      {
        path: 'labels/:labelType',
        name: 'Labels',
        component: Labels,
        beforeEnter: RequireGuradChecked

      },

      {
        path: 'releases',
        name: 'Releases',
        component: Releases,
        beforeEnter: RequireGuradChecked
      },
      {
        path: 'user_profile',
        name: 'User Profile',
        component: UserProfile,
      },
      {
        path: 'releases/:releaseItem',
        name: 'Releases',
        component: Releases,
        beforeEnter: RequireGuradChecked
      },

      {
        path: FixedProperties.ROYALTY_ACCOUNT_ROUTE,
        name: FixedProperties.ROYALTY_ACCOUNT_TITLE,
        component: Royalties,
        beforeEnter: RequireGuradChecked

      },
      {
        path: `${FixedProperties.ROYALTY_ACCOUNT_ROUTE}/:royaltyDate`,
        name: FixedProperties.ROYALTY_ACCOUNT_TITLE,
        component: Royalties,
        beforeEnter: RequireGuradChecked
      },
      {
        path: '*',
        name: 'Not Found Page',
        component: NotFound,

      },



    ]
  }]



